import { render, staticRenderFns } from "./CalendarV2.vue?vue&type=template&id=6775b7c8&scoped=true"
import script from "./CalendarV2.vue?vue&type=script&lang=js"
export * from "./CalendarV2.vue?vue&type=script&lang=js"
import style0 from "./CalendarV2.vue?vue&type=style&index=0&id=6775b7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6775b7c8",
  null
  
)

export default component.exports